require('./bootstrap');


import { createApp } from 'vue';
import RouteList from "./components/RouteList.vue";
import DateSelector from "./components/DateSelector.vue";
import CopyUrl from "./components/CopyUrl.vue";

createApp({
    components: {
        RouteList,
        DateSelector,
        CopyUrl
    }
}).mount('#vue-app');
